import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, useMediaQuery } from "../../../Styles";
import { DataObj, labelToKeyMap, Params, ReportData } from "../../../Definitions/valueTypes";

// TODO
// import { ReportTemplate } from "../../../Assets/TestData/reportTemplates";
import CheckBox, { CheckStyles } from "../../BaseComponents/checkBox";

interface Lvl3_Props {
  reportData?: ReportData
  onReportDataChange: (data: ReportData) => void
}

export default function ReportModalLvl3({ reportData, onReportDataChange }: Lvl3_Props) {
  const {t} = useTranslation()
  const mobileXs = useMediaQuery(`(max-width: 690px)`);

  const checkboxes = useMemo(() => {
    const dataParameters: Params[] = [
      // "locationId", 
      "animalGroupId", 
      // "conditionId", 
      // "attentionId", 
      "milestoneId"
    ] as Params[];

    return dataParameters.map((param, index) => {
      const label = Object.entries(labelToKeyMap).find(([_, key]) => key === (param as any))?.[0];
      
      return (
        <CheckBox
          key={index}
          text={t(`params.${label}`, {defaultValue: `${label}`})}
          checkStyle={CheckStyles.blue}
          isChecked={reportData?.dataParameter?.includes(param as unknown as DataObj)}
          onChange={() => {
            const isChecked = reportData?.dataParameter?.includes(param as unknown as DataObj);
            const updatedParams = isChecked
              ? reportData && reportData.dataParameter?.filter(id => id !== (param as unknown as DataObj))
              : [...(reportData?.dataParameter || []), param as unknown as DataObj];
            onReportDataChange({ ...reportData, reportId: reportData?.reportId || 0, dataParameter: updatedParams });
          }}
        />
      );
    });
  }, [onReportDataChange, reportData, t]);
  
  return(
    <div style={{maxHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{width: "fit-content", display: "grid", gridTemplateColumns: mobileXs ? "1fr 1fr" : "1fr 1fr 1fr", gridTemplateRows: mobileXs ? "1fr 1fr" : "", columnGap: mobileXs ? "50px" : "100px", rowGap: "10px"}}>
        {checkboxes}
      </div>
    </div>
  )
}